import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function SmartSortIcon(props) {
	return (
		<IconBase type="smart-sort" {...props}>
			<path
				clipRule="evenodd"
				d="M5.5875 21.4125C5.97917 21.8042 6.45 22 7 22H17C17.55 22 18.0208 21.8042 18.4125 21.4125C18.8042 21.0208 19 20.55 19 20V10C19 9.45 18.8042 8.97917 18.4125 8.5875C18.0208 8.19583 17.55 8 17 8H7C6.45 8 5.97917 8.19583 5.5875 8.5875C5.19583 8.97917 5 9.45 5 10V20C5 20.55 5.19583 21.0208 5.5875 21.4125ZM8.5 16.6364H11.4167V21L15.5 13.3636H12.5833V9L8.5 16.6364Z"
				fillRule="evenodd"
			/>
			<path d="M6.4375 5.4375C6.14583 5.72917 6 6.08333 6 6.5H18C18 6.08333 17.8542 5.72917 17.5625 5.4375C17.2708 5.14583 16.9167 5 16.5 5H7.5C7.08333 5 6.72917 5.14583 6.4375 5.4375Z" />
			<path d="M7.4375 2.4375C7.14583 2.72917 7 3.08333 7 3.5H17C17 3.08333 16.8542 2.72917 16.5625 2.4375C16.2708 2.14583 15.9167 2 15.5 2H8.5C8.08333 2 7.72917 2.14583 7.4375 2.4375Z" />
		</IconBase>
	);
}
SmartSortIcon.propTypes = iconPropTypes;
